import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { Logo } from 'src/components/logo';

import { NavToggleButton } from 'src/layouts/common';
import { NAV } from 'src/layouts/config-layout';
import { useNavData } from 'src/layouts/dashboard/config-navigation';
import { useActivePlatform } from 'src/hooks/use-active-platform';
import { hideScroll } from 'src/theme/css';

import { NavSection } from './nav-section';
import { TelegramWidget } from '../telegram-widget';

// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export function Sidebar({ openNav, onCloseNav }: Props) {
  const { userRole } = useActivePlatform();

  const { pathname } = useLocation();

  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));

  const navData = useNavData();

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <>
      <Box
        sx={{
          flexGrow: 1,
          minHeight: 0,
          ...hideScroll.y,
        }}
      >
        <Logo sx={{ mt: 3, ml: 4, mb: 1 }} fullIcon height="35px" width="auto" />

        <NavSection
          data={navData}
          slotProps={{
            currentRole: userRole,
          }}
        />
      </Box>

      <TelegramWidget />
    </>
  );

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_VERTICAL },
      }}
    >
      <NavToggleButton />

      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            position: 'fixed',
            width: NAV.W_VERTICAL,
            borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          }}
        >
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          slotProps={{
            paper: {
              sx: {
                width: NAV.W_VERTICAL,
              },
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
